import sortBy from 'lodash/sortBy';
import shuffle from 'lodash/shuffle';

export const Reducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE_LANGUAGE':
      return {...state, language: action.payload, orderBy: 'wordFa'};
    case 'GET_WORDS':
      // Replace items with payload (load all or full refreshed page)
      return {...state, items: action.payload};
    case 'ADD_WORD':
      const newitems = state.items.slice();
      return {
        ...state,
        items: sortBy(newitems.concat(action.payload), state.orderBy),
      };
    case 'REMOVE_WORD':
      return {
        ...state,
        items: state.items.filter((item) => item.key !== action.payload),
      };
    case 'EDIT_WORD':
      return {
        ...state,
        items: sortBy(
            state.items.map((item) =>
            item.key === action.payload.key ?
              {
                ...item,
                wordEn: action.payload.wordEn,
                wordFa: action.payload.wordFa,
                mediaUrl: action.payload.mediaUrl,
                transliteration: action.payload.transliteration,
                // sentences/tags are only patched when provided, so partial
                // updates (e.g. bulk enrichment) never wipe existing values.
                ...(action.payload.sentences !== undefined ?
                  {sentences: action.payload.sentences} : {}),
                ...(action.payload.tags !== undefined ?
                  {tags: action.payload.tags} : {}),
              } :
              item,
            ),
            state.orderBy,
        ),
      };
    case 'SORT_WORDS':
      return {
        ...state,
        orderBy: action.payload,
        items: sortBy(state.items.slice(), action.payload),

      };
    case 'ADD_CATEGORY_TO_WORD':
      return {
        ...state,
        items: state.items.map((item) =>
          item.key === action.payload.key ?
            {...item, tags: action.payload.newTags} :
            item,
        ),
      };
    case 'REMOVE_CATEGORY_FROM_WORD':
      return {
        ...state,
        items: state.items.map((item) =>
          item.key === action.payload.key ?
            {...item, tags: action.payload.newTags} :
            item,
        ),
      };
    case 'SHUFFLE_WORDS':
      return {
        ...state,
        items: shuffle(state.items),
      };
    case 'SET_SORT_ORDER':
      return {
        ...state,
        orderBy: action.payload,
      };
    case 'EMPTY_LIST':
      return {
        ...state,
        items: [],
      };
    case 'SET_LAST_WORD':
      return {...state,
        lastWord: action.payload,
      };
    case 'HAS_MORE_ITEMS':
      return {...state,
        hasMoreItems: action.payload,
      };
    case 'SET_USER':
      return {...state, user: action.payload};

    case 'LOADING':
      return {...state, loading: action.payload};

    case 'TAGS_FILTER':
      return {...state, tagsFilter: action.payload};

    case 'HIDE_TRANSLATION':
      return {...state, hideTranslation: action.payload};

    default:
      return state;
  }
};
